import { getMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const GET_SERVICE_OFFERED = 'GET_SERVICE_OFFERED';
export const GET_SERVICE_OFFERED_SUCCESS = 'GET_SERVICE_OFFERED_SUCCESS';
export const GET_SERVICE_OFFERED_FAILURE = 'GET_SERVICE_OFFERED_FAILURE';

// Action Creators
export const fetchGetServiceOffered = () => ({
  type: GET_SERVICE_OFFERED,
});

export const fetchGetServiceOfferedSuccess = (data) => ({
  type: GET_SERVICE_OFFERED_SUCCESS,
  payload: data,
});

export const fetchGetServiceOfferedFailure = (error) => ({
  type: GET_SERVICE_OFFERED_FAILURE,
  payload: error,
});

// Thunk Function
export const getServiceOfferedCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchGetServiceOffered(data, external));
    try {
      const response = await getMethodWithToken(url.getServiceOffered);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchGetServiceOfferedSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchGetServiceOfferedFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchGetServiceOfferedFailure(error.message));
      if (external && external.toast) {
        external.handleToastError(error.response);
      }
    }
  };
};
